// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__26Fae","row":"styles_row__chnMM","clickable":"styles_clickable__2CJto"};